import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent, OktaAuthGuard } from '@okta/okta-angular';
import { UserRole } from './shared/model';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { CanActivateUserRole } from './canActivateUserRole.guard';
import { environment } from '../environments/environment';
import { MainViewComponent } from './main-view/main-view.component';
import { AdminViewComponent } from './admin-view/admin-view.component';
import { KeywordsViewComponent } from './admin-view/keywords-view/keywords-view.component';
import { MyMeetingsViewComponent } from './my-meetings-view/my-meetings-view.component';
import { RescheduleViewComponent } from './my-meetings-view/reschedule-view/reschedule-view.component';
import { AvailabilityViewComponent } from './supporter-view/availability-view/availability-view.component';
import { SchedulerViewComponent } from './supporter-view/scheduler-view/scheduler-view.component';
import { TeamsViewComponent } from './admin-view/teams-view/teams-view.component';
import { HeadedComponent } from './navBar/headed/headed.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TranslationsViewComponent } from './admin-view/translations-view/translations-view.component';
import { EmailTranslationsViewComponent } from './admin-view/email-translations-view/email-translations-view.component';
import { NoDivisionErrorPageComponent } from './no-division-error-page/no-division-error-page.component';
import { UserNotAssignedToApplicationErrorPageComponent } from './user-not-assigned-to-application-error-page/user-not-assigned-to-application-error-page.component';

const appRoutes: Routes = [
  {
    path: '',
    component: HeadedComponent,
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full'
      },
      {
        path: 'main',
        canActivate: [OktaAuthGuard],
        component: MainViewComponent
      },
      {
        path: 'admin',
        component: AdminViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        data: { role: UserRole.Admin }
      },
      {
        path: 'admin/keywords',
        component: KeywordsViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        canDeactivate: [CanDeactivateGuard],
        data: { role: UserRole.Admin }
      },
      {
        path: 'admin/teams',
        component: TeamsViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        canDeactivate: [CanDeactivateGuard],
        data: { role: UserRole.Admin }
      },
      {
        path: 'admin/translations',
        component: TranslationsViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        canDeactivate: [CanDeactivateGuard],
        data: { role: UserRole.Admin }
      },
      {
        path: 'admin/emailtranslations',
        component: EmailTranslationsViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        canDeactivate: [CanDeactivateGuard],
        data: { role: UserRole.Admin }
      },
      {
        path: 'supporter/availability',
        component: AvailabilityViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        canDeactivate: [CanDeactivateGuard],
        data: { role: UserRole.Technician }
      },
      {
        path: 'supporter',
        component: SchedulerViewComponent,
        canActivate: [OktaAuthGuard, CanActivateUserRole],
        data: { role: UserRole.Technician }
      },
      {
        path: 'meetings',
        component: MyMeetingsViewComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [OktaAuthGuard]
      },
      {
        path: 'meetings/reschedule',
        component: RescheduleViewComponent,
        canActivate: [OktaAuthGuard]
      },
      {
        path: 'no-division-page',
        component: NoDivisionErrorPageComponent,
        canActivate: [OktaAuthGuard]
      }
    ]
  },
  {
    path: 'not-assigned-page',
    component: UserNotAssignedToApplicationErrorPageComponent
  },
  { path: environment.callbackUrl, component: OktaCallbackComponent },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      requiredrole: UserRole.Technician,
      template: 'navigation.page-not-found',
      name: 'Page not found.'
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [CanActivateUserRole]
})
export class AppRoutingModule { }
